/*
 * @Author: your name
 * @Date: 2019-08-01 09:37:32
 * @LastEditTime: 2019-12-09 20:01:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \xinsec-new-security-vue\src\store\index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app'; // 通用数据
import nav from './modules/nav'; // 导航数据

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  modules: {
    app,
    nav
  },
  getters: {},
  mutations: {}
});

export default store;
